export default "__VITE_ASSET__BcBAjhMl__"